module.exports = __webpack_public_path__ + "static/media/DSC00362.d4bbf51c.jpg";